// Labels every team profile shares, Ukrainian: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Особисті дані',
    rows: {
      name: 'Ім’я',
      position: 'Посада',
      birthdate: 'Дата народження',
      nationality: 'Громадянство',
      maritalStatus: 'Сімейний стан',
      location: 'Місцезнаходження',
      languages: 'Мови',
      programmingLanguages: 'Мови програмування',
      certifications: 'Сертифікати',
      publications: 'Публікації',
      links: 'Вебсайт'
    }
  },
  education: {
    title: 'Освіта'
  },
  skills: {
    title: 'Професійні навички'
  },
  experience: {
    title: 'Проєкти та діяльність',
    techLabel: 'Технології'
  },
  downloads: {
    title: 'Завантажити профіль',
    deLabel: 'Завантажити профіль німецькою',
    deDescription: 'PDF німецькою мовою',
    enLabel: 'Завантажити резюме англійською',
    enDescription: 'PDF англійською мовою'
  },
  cta: {
    title: 'Контакти',
    button: 'Зв’язатися'
  },
  pdf: {
    title: 'Профіль',
    personalSection: 'Особисті дані',
    educationSection: 'Освіта',
    experienceSection: 'Проєкти та діяльність',
    skillsLabel: 'Навички'
  }
};
